"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridSPSLHelper = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const GridTradingUtils_1 = require("./GridTradingUtils");
var GridSPSLHelper;
(function (GridSPSLHelper) {
    /**
     * @param params
     *
     * 预估止盈收益额包含：初始挂单形态 到 止盈价格后最终形态变化中已成交卖单的利润 + 未成交卖单的利润
     * 已成交卖单利润 = 已成交的卖单与开仓时的差价收益 - 手续费 = per_volume*当前价到止盈价的格子数 * (已成交卖单均价-开仓价 - 已成交卖单均价 * maker_fee_rate - 开仓价 * take_fee_rate)
     * 未成交卖单利润计算公式（选择关单卖币） = per_volume * 止盈价外的格子数 * (止盈价 - 开仓价 - (止盈价 + 开仓价) * taker_fee_rate )
     * 未成交卖单利润计算公式（选择关单不卖币） = per_volume * 止盈价外的格子数 * (止盈价 - 开仓价 - 开仓价 * taker_fee_rate )
     * 已成交卖单均价 = 当前价到止盈价之间的格子价格和/格子数。
     *
     */
    function calcEstimatedSPInfo(params) {
        const takerFee = new trade_utils_lib_1.SafeDecimal(params.fee.takerFeeRate);
        const makerFee = new trade_utils_lib_1.SafeDecimal(params.fee.makerFeeRate);
        let unTradedOrderProfit = new trade_utils_lib_1.SafeDecimal(0);
        let openPositionPrice = new trade_utils_lib_1.SafeDecimal(0);
        if (params.editMode) {
            openPositionPrice = new trade_utils_lib_1.SafeDecimal(params.curPrice);
        }
        else {
            openPositionPrice = params.conditional ? new trade_utils_lib_1.SafeDecimal(params.conditional) : new trade_utils_lib_1.SafeDecimal(params.curPrice);
        }
        const SPPrice = new trade_utils_lib_1.SafeDecimal(params.stopProfitPrice);
        const openPositionFee = params.useAllCoins ? new trade_utils_lib_1.SafeDecimal(0) : openPositionPrice.mul(takerFee);
        let priceArr = [];
        if (!(!Number(params.top) ||
            !Number(params.bottom) ||
            !Number(params.count) ||
            Number(params.count) < 2 ||
            Number(params.top) <= Number(params.bottom))) {
            priceArr = GridTradingUtils_1.GridTradingUtils.getPriceInterverArr(params.top, params.bottom, params.count, params.gridType);
        }
        const curPriceIndex = GridTradingUtils_1.GridTradingUtils.findPriceIndexInArr(priceArr, params.curPrice);
        priceArr = priceArr.filter((_, i) => i !== curPriceIndex);
        const tradedArr = priceArr.filter((v) => v.greaterThan(openPositionPrice) && v.lessThanOrEqualTo(SPPrice));
        const tradedArrLength = tradedArr.length;
        const tradedArrSum = tradedArr.reduce((sum, item) => {
            return sum.add(item);
        }, new trade_utils_lib_1.SafeDecimal(0));
        const tradedAvgPrice = tradedArrLength > 0 ? tradedArrSum.div(tradedArrLength) : new trade_utils_lib_1.SafeDecimal(0);
        const tradedOrderProfit = new trade_utils_lib_1.SafeDecimal(params.perVolume)
            .mul(tradedArrLength)
            .mul(tradedAvgPrice.sub(openPositionPrice).sub(tradedAvgPrice.mul(makerFee)).sub(openPositionFee));
        //计算止盈价外的挂单格子
        const outRangeGridArr = priceArr.filter((v) => SPPrice.greaterThan(new trade_utils_lib_1.SafeDecimal(params.curPrice)) && new trade_utils_lib_1.SafeDecimal(v).greaterThan(SPPrice));
        const outRangeGridLength = outRangeGridArr.length;
        switch (params.closeMode) {
            case TradeAPILib_1.BotOrderCloseModel.NOT_SELL:
                unTradedOrderProfit = new trade_utils_lib_1.SafeDecimal(params.perVolume)
                    .mul(outRangeGridLength)
                    .mul(SPPrice.sub(openPositionPrice).sub(openPositionFee));
                break;
            case TradeAPILib_1.BotOrderCloseModel.TO_QUOTE:
                unTradedOrderProfit = new trade_utils_lib_1.SafeDecimal(params.perVolume)
                    .mul(outRangeGridLength)
                    .mul(SPPrice.sub(openPositionPrice).sub(SPPrice.add(openPositionPrice).mul(takerFee)));
                break;
            case TradeAPILib_1.BotOrderCloseModel.TO_USDT:
                break;
        }
        const totalProfit = params.editMode
            ? tradedOrderProfit.add(unTradedOrderProfit).add(new trade_utils_lib_1.SafeDecimal(params.totalProfit))
            : tradedOrderProfit.add(unTradedOrderProfit);
        const totalProfitPercent = totalProfit.div(new trade_utils_lib_1.SafeDecimal(params.invest));
        return {
            estimatedProfit: totalProfit,
            estimatedProfitPercent: totalProfitPercent,
        };
    }
    GridSPSLHelper.calcEstimatedSPInfo = calcEstimatedSPInfo;
    function calcEstimatedSLInfo(params) {
        const takerFee = new trade_utils_lib_1.SafeDecimal(params.fee.takerFeeRate);
        const makerFee = new trade_utils_lib_1.SafeDecimal(params.fee.makerFeeRate);
        let unTradedOrderProfit = new trade_utils_lib_1.SafeDecimal(0);
        let openPositionPrice = new trade_utils_lib_1.SafeDecimal(0);
        if (params.editMode) {
            openPositionPrice = new trade_utils_lib_1.SafeDecimal(params.curPrice);
        }
        else {
            openPositionPrice = params.conditional ? new trade_utils_lib_1.SafeDecimal(params.conditional) : new trade_utils_lib_1.SafeDecimal(params.curPrice);
        }
        const SLPrice = new trade_utils_lib_1.SafeDecimal(params.stopLossPrice);
        const openPositionFee = params.useAllCoins ? new trade_utils_lib_1.SafeDecimal(0) : openPositionPrice.mul(takerFee);
        let priceArr = [];
        if (!(!Number(params.top) ||
            !Number(params.bottom) ||
            !Number(params.count) ||
            Number(params.count) < 2 ||
            Number(params.top) <= Number(params.bottom))) {
            priceArr = GridTradingUtils_1.GridTradingUtils.getPriceInterverArr(params.top, params.bottom, params.count, params.gridType);
        }
        const curPriceIndex = GridTradingUtils_1.GridTradingUtils.findPriceIndexInArr(priceArr, params.curPrice);
        priceArr = priceArr.filter((_, i) => i !== curPriceIndex);
        const tradedArr = priceArr.filter((v) => new trade_utils_lib_1.SafeDecimal(v).lessThanOrEqualTo(openPositionPrice) && new trade_utils_lib_1.SafeDecimal(v).greaterThan(SLPrice));
        const tradedArrLength = tradedArr.length;
        const tradedArrSum = tradedArr.reduce((sum, item) => {
            return sum.add(item);
        }, new trade_utils_lib_1.SafeDecimal(0));
        const tradedAvgPrice = tradedArrLength > 0 ? tradedArrSum.div(tradedArrLength) : new trade_utils_lib_1.SafeDecimal(0);
        const tradedOrderProfit = new trade_utils_lib_1.SafeDecimal(params.perVolume)
            .mul(tradedArrLength)
            .mul(SLPrice.sub(tradedAvgPrice).add(tradedAvgPrice.mul(makerFee)).add(openPositionFee));
        //计算止损价外的挂单格子
        const outRangeGridArr = priceArr.filter((v) => new trade_utils_lib_1.SafeDecimal(v).greaterThan(openPositionPrice));
        const outRangeGridLength = outRangeGridArr.length;
        switch (params.closeMode) {
            case TradeAPILib_1.BotOrderCloseModel.NOT_SELL:
                unTradedOrderProfit = new trade_utils_lib_1.SafeDecimal(params.perVolume)
                    .mul(outRangeGridLength)
                    .mul(SLPrice.sub(openPositionPrice).add(openPositionFee));
                break;
            case TradeAPILib_1.BotOrderCloseModel.TO_QUOTE:
                unTradedOrderProfit = new trade_utils_lib_1.SafeDecimal(params.perVolume)
                    .mul(outRangeGridLength)
                    .mul(SLPrice.sub(openPositionPrice).add(openPositionPrice.add(SLPrice).mul(takerFee)));
                break;
            case TradeAPILib_1.BotOrderCloseModel.TO_USDT:
                break;
        }
        const totalProfit = params.editMode
            ? tradedOrderProfit.add(unTradedOrderProfit).add(new trade_utils_lib_1.SafeDecimal(params.totalProfit))
            : tradedOrderProfit.add(unTradedOrderProfit);
        const totalProfitPercent = totalProfit.div(new trade_utils_lib_1.SafeDecimal(params.invest));
        return {
            estimatedProfit: totalProfit,
            estimatedProfitPercent: totalProfitPercent,
        };
    }
    GridSPSLHelper.calcEstimatedSLInfo = calcEstimatedSLInfo;
})(GridSPSLHelper || (exports.GridSPSLHelper = GridSPSLHelper = {}));
